import { t } from "@hakili/i18n";
import { useState } from "react";

/**
 * `round C5-2`, `M1`: **the cabinet's login.** The partner path, not the
 * client's OTP (`00-SPINE` R-07): the responsable and his field experts are
 * staff of a partner organisation , email, password, the invitation that
 * set it. The server's own sentence is shown, as every other surface's login
 * shows it; a refusal without a sentence sends a person back to the password
 * they just used. At a phone's width and at a desk's, one column.
 */
export function Connexion(props: {
  readonly connecter: (credentials: { email: string; password: string }) => Promise<void>;
  /** Why this screen is showing, when the api authenticated somebody this surface will not seat. */
  readonly motif?: string | undefined;
}): React.JSX.Element {
  const { connecter, motif } = props;
  const [email, setEmail] = useState("");
  const [motDePasse, setMotDePasse] = useState("");
  const [enCours, setEnCours] = useState(false);

  const soumettre = async (): Promise<void> => {
    if (enCours) return;
    setEnCours(true);
    try {
      await connecter({ email, password: motDePasse });
    } finally {
      setEnCours(false);
    }
  };

  return (
    <div className="mx-auto mt-12 w-full max-w-sm px-5">
      <div className="rounded-2xl border border-gray-200 bg-white px-5 py-5">
        <h1 className="text-lg font-semibold tracking-tight text-gray-900">{t("expert.connexion.titre")}</h1>
        <p className="mt-1 text-sm text-gray-500">{t("expert.connexion.sousTitre")}</p>
        <label className="mt-4 block text-xs font-medium text-gray-500" htmlFor="expert-email">
          {t("expert.connexion.email")}
        </label>
        <input
          id="expert-email"
          type="email"
          autoComplete="username"
          value={email}
          onChange={(event) => {
            setEmail(event.target.value);
          }}
          className="mt-1 w-full rounded-xl border border-gray-200 px-3 py-2 text-sm"
          data-testid="connexion-email"
        />
        <label className="mt-3 block text-xs font-medium text-gray-500" htmlFor="expert-motdepasse">
          {t("expert.connexion.motDePasse")}
        </label>
        <input
          id="expert-motdepasse"
          type="password"
          autoComplete="current-password"
          value={motDePasse}
          onChange={(event) => {
            setMotDePasse(event.target.value);
          }}
          className="mt-1 w-full rounded-xl border border-gray-200 px-3 py-2 text-sm"
          data-testid="connexion-motdepasse"
        />
        <button
          type="button"
          disabled={enCours}
          onClick={() => {
            void soumettre();
          }}
          className="mt-4 w-full rounded-xl bg-indigo-600 py-2.5 text-sm font-medium text-white disabled:opacity-40"
          data-testid="connexion-entrer"
        >
          {t("expert.connexion.entrer")}
        </button>
        {motif === undefined ? null : (
          <p role="alert" className="mt-3 text-sm text-rose-600" data-testid="connexion-refus">
            {motif}
          </p>
        )}
      </div>
    </div>
  );
}
